import throttle from "lodash/throttle";

class IFrame {
    constructor() {
        const throttledResize = throttle(IFrame.resize, 500);

        IFrame.resize();

        window.addEventListener("resize", throttledResize);

        // Check for changes in the DOM and trigger a resize
        const observer = new MutationObserver(() => {
            throttledResize();
        });

        observer.observe(document, {
            attributes: true,
            childList: true,
            subtree: true,
        });

        // Resize every 5 seconds
        setInterval(() => {
            IFrame.resize();
        }, 5000);

        window.addEventListener("message", this.receiveMessage, false);

        // Send page title to parent window on load and on DOM changes
        this.pageStatus();
    }

    pageStatus() {
        // Define page mapping with selectors and identifiers
        const pageDefinitions = [
            { selector: ".spx-header-container", identifier: "Checkout" },
            {
                selector: ".SpektrixPage.EventDetails",
                identifier: "EventDetails",
                title: "Event Details",
            },
            {
                selector: ".SpektrixPage.LoginLogout",
                identifier: "LoginLogout",
                title: "Login",
            },
            {
                selector: ".SpektrixPage.ForgotPassword",
                identifier: "ForgotPassword",
                title: "Forgot Password",
            },
            {
                selector: ".SpektrixPage.ChooseSeats",
                identifier: "ChooseSeats",
                title: "Choose Seats",
            },
            {
                selector: ".SpektrixPage.EditTickets",
                identifier: "EditTickets",
                title: "Edit Tickets",
            },
            {
                selector: ".SpektrixPage.Basket2",
                identifier: "Basket2",
                title: "Basket",
            },
            {
                selector: ".SpektrixPage.Basket",
                identifier: "Basket",
                title: "Basket",
            },
            {
                selector: ".SpektrixPage.MyAccount",
                identifier: "MyAccount",
            },
            {
                selector: ".SpektrixPage.SupplementaryEventsPage",
                identifier: "SupplementaryEventsPage",
                title: "Extras",
            },
            {
                selector: ".SpektrixPage.ChangePassword",
                identifier: "ChangePassword",
                title: "Change Password",
            },
            {
                selector: ".SpektrixPage.Multibuypage",
                identifier: "Multibuypage",
                title: "Multibuy",
            },
            {
                selector: ".SpektrixPage.EditAddress",
                identifier: "EditAddress",
                title: "Edit Address",
            },
            {
                selector: ".SpektrixPage.Donations",
                identifier: "Donations",
            },
            {
                selector: ".SpektrixPage.Cookies",
                identifier: "Cookies",
                title: "Cookies",
            },
            {
                selector: ".SpektrixPage.NewAccount",
                identifier: "NewAccount",
                title: "Create Account",
            },
        ];

        // Get default identifier from h1 content (fallback)
        const h1 = document.querySelector("h1");
        let currentPage = {};

        // Loop through page definitions to find a match
        for (const page of pageDefinitions) {
            if (document.querySelector(page.selector)) {
                currentPage.identifier = page.identifier;
                currentPage.title = page.title ?? "";

                break;
            }
        }

        const message = {
            currentPage: currentPage,
        };

        window.parent.postMessage(message, "*");
    }

    static resize() {
        setTimeout(() => {
            let newHeight = document.body.scrollHeight;

            newHeight = Math.round(newHeight);

            const urlParams = new URLSearchParams(window.location.search);
            const uid = urlParams.get("uid");

            let message = {
                resize: newHeight,
                uid: uid,
            };

            window.parent.postMessage(JSON.stringify(message), "*");
        }, 200);
    }

    receiveMessage(e) {
        if (e.data.basket_offers) {
            if (
                $(".SpektrixPage.Basket2").length &&
                $(".Item.Instance").length
            ) {
                $(".Savings").after(e.data.basket_offers);
            }
        }

        if (e.data.gift_amount) {
            $("input.MoneyTextBox").val(Number(e.data.gift_amount));
        }

        if (e.data.origin) {
            origin = e.data.origin;

            if ($(".LoginLogout .Account_Link .Link")) {
                let el = $(".LoginLogout .Account_Link:first .Link");
                el.attr("href", `${e.data.origin}/register`);
                el.attr("target", "_top");
            }
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new IFrame();
});

export default IFrame;
